import React from 'react';

/**
 * Lot DN — « Derniers dépôts » CessionPME : la trace des dépôts automatiques de nuit et des
 * dépôts manuels. Sans elle, un échec nocturne ne se verrait qu'une fois les annonces perdues.
 */
const HEURES_SANS_DEPOT = 36;

const formateur = new Intl.DateTimeFormat('fr-FR', {
  timeZone: 'Europe/Paris',
  day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
});

// JJ/MM/AAAA HH h MM, à l'heure de Paris.
export const dateDepot = (valeur) => {
  if (!valeur) return '';
  const date = new Date(valeur);
  if (Number.isNaN(date.getTime())) return '';
  const p = Object.fromEntries(formateur.formatToParts(date).map(x => [x.type, x.value]));
  return `${p.day}/${p.month}/${p.year} ${p.hour} h ${p.minute}`;
};

export const CessionPmeDepots = ({ depots }) => {
  if (!Array.isArray(depots) || depots.length === 0) return null;

  const dernierReussi = depots.find(d => d.succes);
  const sansDepot = dernierReussi
    && (Date.now() - new Date(dernierReussi.date).getTime()) > HEURES_SANS_DEPOT * 3600 * 1000;

  return (
    <div className="mt-3" data-testid="cessionpme-depots">
      {sansDepot && (
        <p className="mb-2 rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-xs font-semibold text-amber-800"
           data-testid="cessionpme-depots-alerte">
          <i className="bi bi-exclamation-triangle mr-1" />
          Aucun dépôt réussi depuis le {dateDepot(dernierReussi.date)}.
        </p>
      )}
      <p className="text-[12px] font-semibold text-slate-600 mb-1">Derniers dépôts</p>
      <ul className="space-y-1.5 text-xs text-slate-700">
        {depots.slice(0, 5).map(d => (
          <li key={d.id}
              data-testid="cessionpme-depot-ligne"
              className="flex flex-col gap-0.5 rounded-lg border border-slate-200 bg-white px-2.5 py-1.5 sm:flex-row sm:items-baseline sm:gap-2">
            <span className="shrink-0 tabular-nums text-slate-500">{dateDepot(d.date)}</span>
            <span className="shrink-0 text-slate-500">
              {d.origine === 'automatique' ? 'Automatique' : 'Manuel'}
            </span>
            <span className={`break-words ${d.succes ? 'text-emerald-700' : 'text-red-700'}`}>
              {d.succes
                ? `✅ Réussi — ${d.nb_biens} bien${d.nb_biens > 1 ? 's' : ''} dans ${d.fichier}`
                : `❌ Échec — ${d.message}`}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};
